import { createFileRoute } from '@tanstack/react-router';

import { AdminRevenueCatSettingsPage } from '@pages/admin';

export const Route = createFileRoute(
  '/$locale/_authenticated/admin/settings/operations/integrations/revenuecat'
)({ component: AdminRevenueCatSettingsPage });
